import { ISearchStore } from './index'

export default {
  isLoading: false,
  isReady: false,
} as ISearchStore
